<template lang="pug">
.modal
  .backdrop(@click.self="closeModal")
  .body
    .content
      .filter(v-if="parameter !== 'cable'")
        label 
          span Select RF Series
          div
            select(v-model="filter")
              option(:value="null", selected) All Series
              option(v-for="line in productLines", :value="line") {{ line }}
            i.glyph-arrow-down
      TransitionShuffle.products(tag="div")
        SelectionProduct(
          @selected="closeModal",
          v-for="(product, i) in visible",
          :key="`${product.sku}-${i}`",
          :product="product",
          :parameter="parameter"
        )
    .arrow(:style="arrowPos")
</template>


<script>
import TransitionShuffle from "@/transitions/Shuffle";
import SelectionProduct from "./SelectionProduct";

import { mapGetters } from "vuex";
import { cloneDeep } from "lodash-es";

export default {
  name: "SelectionModal",
  props: ["toggle", "products", "parameter"],
  components: {
    TransitionShuffle,
    SelectionProduct,
  },
  data() {
    return {
      filter: null,
      modal: null,
      arrowPos: { left: 0 },
    };
  },
  computed: {
    ...mapGetters(["model", "productLookup"]),
    visible() {
      let products = cloneDeep(this.products);
      products = products
        .map((p) => {
          p.viable = this.checkViability(p);
          return p;
        })
        .sort((a, b) => b.viable - a.viable);
      return this.filter
        ? products.filter((p) => p.meta.line === this.filter)
        : products;
    },
    productLines() {
      return this.products
        .reduce((lines, product) => {
          if (!lines.includes(product.meta.line)) lines.push(product.meta.line);
          return lines;
        }, [])
        .sort();
    },
  },
  methods: {
    checkViability(product) {
      if (product.category === "cable") {
        const left = this.productLookup(this.model.connector_left);
        const right = this.productLookup(this.model.connector_right);
        if (left && right) {
          return (
            left.meta.compatibility.includes(product.sku) &&
            right.meta.compatibility.includes(product.sku)
          );
        } else if (right) {
          return right.meta.compatibility.includes(product.sku);
        } else if (left) {
          return left.meta.compatibility.includes(product.sku);
        } else return true;
      } else {
        const { cable } = this.model;
        if (cable) {
          return product.meta.compatibility.includes(cable);
        } else return true;
      }
    },
    getArrowPos() {
      const { toggle, $el } = this;
      const toggleRect = toggle.getBoundingClientRect();
      const modalRect = $el.getBoundingClientRect();

      this.arrowPos.left = `${
        toggleRect.left - modalRect.left + toggle.offsetWidth / 2
      }px`;
    },
    closeModal() {
      this.$emit("close");
    },
  },
  mounted() {
    this.getArrowPos();
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 2000;
  position: absolute;
  bottom: 3.25rem;
  left: 0;
  width: 100%;
  //padding-bottom: 4rem;
}

.backdrop {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($black, 0.4);
  z-index: -1;
  cursor: pointer;
}

.body {
  display: flex;
  flex-direction: column;
  filter: drop-shadow(0 -0.175rem 0.125rem rgba($black, 0.15));
  transform: translateY(-30px);
  animation: drop 250ms 75ms ease forwards;
}

@keyframes drop {
  to {
    transform: translateY(0);
  }
}

.arrow {
  position: relative;
  height: 0;
  width: 0;
  border-bottom: 1rem solid $lightGray;
  border-right: 1.125rem solid transparent;
  border-left: 1.125rem solid transparent;
  transform: translateX(-50%) rotate(180deg);
}

.content {
  display: flex;
  flex-direction: column;
  background: $lightGray;
  padding: clamp(1.125rem, 3vw, 2rem);
  max-height: 380px;
  overflow-y: auto;
  @include mq(lg) {
    max-height: 440px;
  }
}

.filter {
  display: flex;
  margin: 0 0 2rem;

  label {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem 1rem;
    
    span {
      font-size: 0.75rem;
      text-transform: uppercase;
      font-weight: 700;
    }

    div {
      display: flex;
      position: relative;
      border: 1px solid $midGray;
      min-width: 190px;
      height: 2.5rem;
      background: $white;

      select {
        appearance: none;
        border: none;
        background: transparent;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        line-height: normal;
      }

      i {
        position: absolute;
        top: 50%;
        right: 0.5rem;
        transform: translateY(-50%);
        line-height: 1;
        font-size: 0.75rem;
        transition: 0.25s ease;
      }
    }
  }
}

.products {
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(6, minmax(150px, 1fr));
  flex-wrap: wrap;
  gap: 1.5rem;
}
</style>